module.exports = __webpack_public_path__ + "img/cmu.c352903a.png";